// NOTE This file is auto-generated by Contentlayer

export { isType } from 'contentlayer/client'

// NOTE During development Contentlayer imports from `.mjs` files to improve HMR speeds.
// During (production) builds Contentlayer it imports from `.json` files to improve build performance.
import allHelpPosts from './HelpPost/_index.json' assert { type: 'json' }
import allLandingPosts from './LandingPost/_index.json' assert { type: 'json' }
import allBlogGuides from './BlogGuide/_index.json' assert { type: 'json' }

export { allHelpPosts, allLandingPosts, allBlogGuides }

export const allDocuments = [...allHelpPosts, ...allLandingPosts, ...allBlogGuides]


